@use '../../scss/utility';
@use './avatar-vars';

:host {
  @include avatar-vars.wb-avatar-vars;

  position: relative;
  display: flex;
  width: var(--avatar-size);
  height: var(--avatar-size);
  justify-content: center;
  align-items: center;
  border-radius: var(--avatar-border-radius);
  color: var(--avatar-text-color);
  background-color: var(--avatar-background-color);
  cursor: pointer;
  overflow: hidden;
}

.icon,
::slotted(.wb-icon) {
  --size: var(--avatar-icon-size);
  fill: var(--avatar-icon-color);
}

.initials {
  font-size: var(--avatar-font-size);
}

::slotted(img) {
  border-radius: var(--avatar-border-radius);
  width: var(--avatar-size);
  height: var(--avatar-size);
  position: absolute; // places the image above the other elements within the avatar
}

:host(:not([disable-hover]):hover),
:host(:not([disable-hover]).highlighted) {
  @include avatar-vars.wb-avatar-hover-vars;

  .overlay {
    position: absolute;
    width: var(--avatar-size);
    height: var(--avatar-size);
    border-radius: var(--avatar-border-radius);
    background-color: var(--avatar-overlay-background-color);
    z-index: 1;
  }
}

:host(:focus-visible) {
  @include avatar-vars.wb-avatar-focus-vars;

  outline-offset: var(--avatar-border-ring-weight);
  outline: var(--avatar-border-ring-weight) solid var(--avatar-border-ring-color);
  border-radius: var(--avatar-border-radius);
}

:host([size='xxs']) {
  @include avatar-vars.wb-avatar-xxs-vars;
}

:host([size='xs']) {
  @include avatar-vars.wb-avatar-xs-vars;
}

:host([size='s']) {
  @include avatar-vars.wb-avatar-s-vars;
}

:host([size='m']) {
  @include avatar-vars.wb-avatar-m-vars;
}

:host([size='l']) {
  @include avatar-vars.wb-avatar-l-vars;
}

:host([size='xl']) {
  @include avatar-vars.wb-avatar-xl-vars;
}

:host([size='xxl']) {
  @include avatar-vars.wb-avatar-xxl-vars;
}
